import type { CrmMessages } from "./englishCrmMessages";

export const chineseCrmMessages = {
  resources: {
    companies: {
      name: "公司 |||| 公司",
      forcedCaseName: "公司",
      fields: {
        name: "公司名称",
        website: "网站",
        linkedin_url: "LinkedIn 链接",
        phone_number: "电话号码",
        created_at: "创建时间",
        nb_contacts: "联系人数量",
        revenue: "营收",
        sector: "行业",
        size: "规模",
        tax_identifier: "税号",
        address: "地址",
        city: "城市",
        zipcode: "邮政编码",
        state_abbr: "省/州",
        country: "国家",
        description: "描述",
        context_links: "背景链接",
        sales_id: "客户经理",
      },
      empty: {
        description: "公司列表似乎是空的。",
        title: "未找到公司",
      },
      import: {
        title: "导入公司",
      },
      field_categories: {
        contact: "联系方式",
        additional_info: "其他信息",
        address: "地址",
        context: "背景",
      },
      action: {
        create: "创建公司",
        edit: "编辑公司",
        new: "新建公司",
        show: "查看公司",
      },
      added_on: "添加于 %{date}",
      followed_by: "由 %{name} 跟进",
      followed_by_you: "由你跟进",
      no_contacts: "暂无联系人",
      nb_contacts: "%{smart_count} 位联系人 |||| %{smart_count} 位联系人",
      nb_deals: "%{smart_count} 个商机 |||| %{smart_count} 个商机",
      sizes: {
        one_employee: "1 名员工",
        two_to_nine_employees: "2-9 名员工",
        ten_to_forty_nine_employees: "10-49 名员工",
        fifty_to_two_hundred_forty_nine_employees: "50-249 名员工",
        two_hundred_fifty_or_more_employees: "250 名及以上员工",
      },
      autocomplete: {
        create_error: "创建公司时出错",
        create_item: "创建 %{item}",
        create_label: "开始输入以创建新公司",
      },
    },
    contacts: {
      name: "联系人 |||| 联系人",
      forcedCaseName: "联系人",
      field_categories: {
        background_info: "背景信息",
        identity: "身份",
        misc: "其他",
        personal_info: "个人信息",
        position: "职位",
      },
      fields: {
        first_name: "名",
        last_name: "姓",
        last_seen: "最近联系",
        title: "职位",
        company_id: "公司",
        email_jsonb: "邮箱地址",
        email: "邮箱",
        phone_jsonb: "电话号码",
        phone_number: "电话号码",
        linkedin_url: "LinkedIn 链接",
        background: "背景信息（简介、相识经过等）",
        has_newsletter: "订阅通讯",
        sales_id: "客户经理",
      },
      action: {
        add: "添加联系人",
        add_first: "添加你的第一个联系人",
        create: "创建联系人",
        edit: "编辑联系人",
        export_vcard: "导出为 vCard",
        new: "新建联系人",
        show: "查看联系人",
      },
      autocomplete: {
        create_item: "创建 %{item}",
        create_label: "开始输入以创建新联系人",
      },
      background: {
        last_activity_on: "最近动态 %{date}",
        added_on: "添加于 %{date}",
        followed_by: "由 %{name} 跟进",
        followed_by_you: "由你跟进",
        status_none: "无",
      },
      position_at: "%{title}，就职于",
      position_at_company: "%{title}，就职于 %{company}",
      empty: {
        description: "联系人列表似乎是空的。",
        title: "未找到联系人",
      },
      import: {
        title: "导入联系人",
      },
      inputs: {
        genders: {
          male: "他",
          female: "她",
          nonbinary: "TA",
        },
        personal_info_types: {
          work: "工作",
          home: "家庭",
          other: "其他",
        },
      },
      list: {
        error_loading: "加载联系人失败",
      },
      show: {
        error_loading: "加载联系人失败",
      },
      bulk_tag: {
        action: "打标签",
        back: "返回标签",
        create_description: "新建标签并应用到所选联系人。",
        description: "为所选联系人选择已有标签，或新建一个标签。",
        empty: "还没有标签。创建一个，以便为所选联系人打标签。",
        error: "为联系人添加标签失败",
        removed:
          "已从 %{smart_count} 位联系人移除标签 |||| 已从 %{smart_count} 位联系人移除标签",
        success:
          "已为 %{smart_count} 位联系人添加标签 |||| 已为 %{smart_count} 位联系人添加标签",
        title: "为联系人添加标签",
      },
      merge: {
        action: "与另一位联系人合并",
        confirm: "合并联系人",
        current_contact: "当前联系人（将被删除）",
        description: "将此联系人与另一位联系人合并。",
        error: "合并联系人失败",
        merging: "正在合并……",
        no_additional_data: "没有可合并的其他数据",
        select_target: "请选择要合并的联系人",
        success: "联系人已成功合并",
        target_contact: "目标联系人（将保留）",
        title: "合并联系人",
        warning_description: "所有数据将转移到第二个联系人。此操作无法撤销。",
        warning_title: "警告：破坏性操作",
        what_will_be_merged: "将合并的内容：",
      },
      filters: {
        before_last_month: "上月之前",
        before_this_month: "本月之前",
        before_this_week: "本周之前",
        managed_by_me: "由我负责",
        search: "搜索姓名、公司……",
        this_week: "本周",
        today: "今天",
        tags: "标签",
        tasks: "任务",
      },
      hot: {
        empty_change_status:
          "为联系人添加备注，并点击“显示选项”，即可更改该联系人的状态。",
        empty_hint: "状态为“热门”的联系人会显示在这里。",
        title: "热门联系人",
      },
    },
    deals: {
      name: "商机 |||| 商机",
      fields: {
        name: "名称",
        description: "描述",
        company_id: "公司",
        contact_ids: "联系人",
        categories: "类别",
        amount: "预算",
        expected_closing_date: "预计成交日期",
        stage: "阶段",
      },
      action: {
        back_to_deal: "返回商机",
        create: "创建商机",
        new: "新建商机",
      },
      field_categories: {
        misc: "其他",
      },
      filters: {
        only_mine: "仅我负责的商机",
      },
      archived: {
        action: "归档",
        error: "错误：商机未归档",
        list_title: "已归档商机",
        success: "商机已归档",
        title: "已归档商机",
        view: "查看已归档商机",
      },
      inputs: {
        linked_to: "关联到",
      },
      unarchived: {
        action: "移回看板",
        error: "错误：商机未取消归档",
        success: "商机已取消归档",
      },
      updated: "商机已更新",
      empty: {
        before_create: "后再创建商机。",
        description: "商机列表似乎是空的。",
        title: "未找到商机",
      },
      import: {
        title: "导入商机",
      },
      invalid_date: "日期无效",
    },
    notes: {
      name: "备注 |||| 备注",
      forcedCaseName: "备注",
      fields: {
        status: "状态",
        date: "日期",
        attachments: "附件",
        contact_id: "联系人",
        deal_id: "商机",
      },
      action: {
        add: "添加备注",
        add_first: "添加你的第一条备注",
        delete: "删除备注",
        edit: "编辑备注",
        update: "更新备注",
        add_this: "添加此备注",
      },
      sheet: {
        create: "创建备注",
        create_for: "为 %{name} 创建备注",
        edit: "编辑备注",
        edit_for: "编辑 %{name} 的备注",
      },
      deleted: "备注已删除",
      empty: "还没有备注",
      author_added: "%{name} 添加了一条备注",
      you_added: "你添加了一条备注",
      me: "我",
      list: {
        error_loading: "加载备注失败",
      },
      note_for_contact: "%{name} 的备注",
      stepper: {
        hint: "前往联系人页面并添加备注",
      },
      added: "备注已添加",
      inputs: {
        add_note: "添加备注",
        options_hint: "（附加文件，或修改详情）",
        show_options: "显示选项",
      },
      actions: {
        attach_document: "附加文档",
      },
      validation: {
        note_or_attachment_required: "需要填写备注或添加附件",
      },
    },
    sales: {
      name: "用户 |||| 用户",
      fields: {
        first_name: "名",
        last_name: "姓",
        email: "邮箱",
        secondary_email: "备用邮箱",
        secondary_emails: "备用邮箱",
        administrator: "管理员",
        disabled: "已禁用",
      },
      create: {
        error: "创建用户时出错。",
        success: "用户已创建。对方很快会收到一封设置密码的邮件。",
        title: "创建新用户",
      },
      edit: {
        error: "出错了，请重试。",
        record_not_found: "未找到记录",
        success: "用户已更新",
        title: "编辑 %{name}",
      },
      action: {
        new: "新建用户",
      },
    },
    tasks: {
      name: "任务 |||| 任务",
      forcedCaseName: "任务",
      fields: {
        text: "描述",
        due_date: "截止日期",
        type: "类型",
        contact_id: "联系人",
        due_short: "到期",
      },
      action: {
        add: "添加任务",
        create: "创建任务",
        edit: "编辑任务",
      },
      actions: {
        postpone_next_week: "推迟到下周",
        postpone_tomorrow: "推迟到明天",
        title: "任务操作",
      },
      added: "任务已添加",
      deleted: "任务已删除",
      dialog: {
        create: "创建任务",
        create_for: "为 %{name} 创建任务",
      },
      sheet: {
        edit: "编辑任务",
        edit_for: "编辑 %{name} 的任务",
      },
      empty: "还没有任务",
      empty_list_hint: "添加到联系人的任务会显示在这里。",
      filters: {
        later: "以后",
        overdue: "已逾期",
        this_week: "本周",
        today: "今天",
        tomorrow: "明天",
        with_pending: "有待办任务",
      },
      regarding_contact: "（关于：%{name}）",
      updated: "任务已更新",
    },
    tags: {
      name: "标签 |||| 标签",
      action: {
        add: "添加标签",
        create: "新建标签",
      },
      dialog: {
        color: "颜色",
        create_title: "创建新标签",
        edit_title: "编辑标签",
        name_label: "标签名称",
        name_placeholder: "输入标签名称",
      },
      empty: "还没有标签。",
    },
  },
  crm: {
    action: {
      reset_password: "重置密码",
    },
    auth: {
      first_name: "名",
      last_name: "姓",
      confirm_password: "确认密码",
      confirmation_required: "请点击我们刚刚发送到你邮箱的链接，以确认账户。",
      recovery_email_sent: "如果你是已注册用户，很快会收到一封密码找回邮件。",
      sign_in_failed: "登录失败。",
      sign_in_google_workspace: "使用 Google Workplace 登录",
      signup: {
        create_account: "创建账户",
        create_first_user: "创建第一个用户账户以完成设置。",
        creating: "正在创建……",
        initial_user_created: "初始用户已创建",
      },
      welcome_title: "毫厘工作台",
    },
    common: {
      account_manager: "客户经理",
      activity: "动态",
      added: "已添加",
      details: "详情",
      last_activity_with_date: "最近动态 %{date}",
      load_more: "加载更多",
      misc: "其他",
      past: "已过期",
      read_more: "查看更多",
      retry: "重试",
      show_less: "收起",
      copied: "已复制",
      copy: "复制",
      loading: "加载中……",
      me: "我",
      task_count: "%{smart_count} 项任务 |||| %{smart_count} 项任务",
    },
    changelog: {
      title: "更新日志",
    },
    activity: {
      added_company: "%{name} 添加了公司",
      you_added_company: "你添加了公司",
      added_contact: "%{name} 添加了联系人",
      you_added_contact: "你添加了联系人",
      added_note: "%{name} 添加了备注，关于",
      you_added_note: "你添加了备注，关于",
      added_note_about_deal: "%{name} 添加了商机备注",
      you_added_note_about_deal: "你添加了商机备注",
      added_deal: "%{name} 添加了商机",
      you_added_deal: "你添加了商机",
      at_company: "，所属",
      to: "至",
      load_more: "加载更多动态",
    },
    dashboard: {
      deals_chart: "即将成交的商机收入",
      deals_pipeline: "商机管道",
      latest_activity: "最新动态",
      latest_activity_error: "加载最新动态失败",
      latest_notes: "我的最新备注",
      latest_notes_added_ago: "添加于 %{timeAgo}",
      stepper: {
        install: "安装 Atomic CRM",
        progress: "已完成 %{step}/3",
        whats_next: "接下来做什么？",
      },
      upcoming_tasks: "即将到期的任务",
    },
    data_import: {
      button: "导入 CSV",
      complete:
        "导入完成。已导入 %{importCount} 条记录，有 %{errorCount} 个错误",
      csv_file: "CSV 文件",
      error: "无法导入此文件，请确认提供的是有效的 CSV 文件。",
      in_progress: "正在导入……",
      progress:
        "已导入 %{importCount} / %{rowCount} 条记录，有 %{errorCount} 个错误。",
      remaining_time: "预计剩余时间：",
      resource: "资源",
      sample_download: "下载 CSV 示例",
      sample_hint: "可以以此 CSV 示例文件作为模板",
      start: "开始导入",
      stop: "停止导入",
      stopped:
        "导入已停止。已导入 %{importCount} 条记录，有 %{errorCount} 个错误",
      title: "导入数据",
    },
    header: {
      import_data: "从 JSON 导入",
    },
    search: {
      title: "搜索",
      placeholder: "搜索联系人、公司、商机、任务和备注……",
      hint: "至少输入 %{min} 个字符后开始搜索",
      empty: "未找到结果",
      error: "搜索暂不可用，请重试。",
      untitled_result: "（无标题）",
      show_more: "显示更多",
      groups: {
        contacts: "联系人",
        companies: "公司",
        deals: "商机",
        tasks: "任务",
        contact_notes: "联系人备注",
        deal_notes: "商机备注",
      },
    },
    image_editor: {
      change: "更换",
      drop_hint: "拖放文件以上传，或点击选择文件。",
      editable_content: "可编辑内容",
      title: "上传并调整图片",
      update_image: "更新图片",
    },
    import: {
      action: {
        download_error_report: "下载错误报告",
        import: "导入",
        import_another: "导入另一个文件",
      },
      error: {
        unable: "无法导入此文件。",
      },
      idle: {
        description_1: "你可以导入用户、公司、联系人、备注和任务。",
        description_2: "数据必须放在与以下示例匹配的 JSON 文件中：",
      },
      status: {
        all_success: "所有记录均已成功导入。",
        complete: "导入完成。",
        failed: "失败",
        imported: "已导入",
        in_progress: "正在导入，请不要离开此页面。",
        some_failed: "部分记录未能导入。",
        table_caption: "导入状态",
      },
      title: "从 JSON 导入",
    },
    settings: {
      about: "关于",
      companies: {
        sectors: "行业",
      },
      dark_mode_logo: "深色模式标志",
      deals: {
        categories: "类别",
        currency: "货币",
        pipeline_help: "选择哪些商机阶段计入商机管道。",
        pipeline_statuses: "管道状态",
        stages: "阶段",
      },
      light_mode_logo: "浅色模式标志",
      notes: {
        statuses: "状态",
      },
      reset_defaults: "恢复默认",
      save_error: "保存配置失败",
      saved: "配置已保存",
      saving: "正在保存……",
      tasks: {
        types: "类型",
      },
      preferences: "偏好设置",
      title: "设置",
      app_title: "应用标题",
      sections: {
        branding: "品牌",
      },
      validation: {
        duplicate: "重复的%{display_name}：%{items}",
        in_use: "无法移除仍被商机使用的%{display_name}：%{items}",
        validating: "正在校验……",
        entities: {
          categories: "类别",
          stages: "阶段",
        },
      },
    },
    theme: {
      dark: "深色",
      label: "主题",
      light: "浅色",
      system: "跟随系统",
    },
    language: "语言",
    navigation: {
      label: "CRM 导航",
    },
    profile: {
      add_secondary_email: "添加邮箱",
      email_taken: "%{email} 已被其他用户使用",
      no_secondary_emails: "无",
      secondary_email_invalid: "%{email} 不是有效的邮箱地址",
      secondary_email_is_primary: "%{email} 已是你的主邮箱",
      secondary_email_taken: "%{email} 已被其他用户使用",
      too_many_secondary_emails: "备用邮箱不能超过 10 个",
      secondary_emails_help: "你用来发信的其他地址。将其中一项留空即可删除。",
      inbound: {
        description:
          "你可以开始向服务器的入站邮箱发送邮件，例如把它添加到 %{field} 字段。Atomic CRM 会处理这些邮件，并为相应联系人添加备注。",
        title: "入站邮件",
      },
      mcp: {
        title: "MCP 服务器",
        description:
          "使用此 URL，通过模型上下文协议（MCP）将你的 AI 助手连接到 CRM 数据。",
      },
      password: {
        change: "修改密码",
      },
      password_reset_sent: "重置密码邮件已发送到你的邮箱",
      record_not_found: "未找到记录",
      title: "个人资料",
      updated: "个人资料已更新",
      update_error: "出错了，请重试",
    },
    validation: {
      invalid_url: "必须是有效的 URL",
      invalid_linkedin_url: "URL 必须来自 linkedin.com",
    },
  },
} satisfies CrmMessages;
